<template>
  <div class="nissan-phone">
    <el-form
      class="login-form form-custom clearfix"
      :class="{ 'mgb-more': fromGuest }"
      ref="form"
      label-position="top"
      label-width="80px"
      @submit.native.prevent
      :hide-required-asterisk="true"
      :rules="rules"
      :model="form"
    >
      <!-- 手机号码 -->
      <el-form-item class="form-item-primary" prop="phone">
        <BaseInput
          v-if="hasBanner || isMergeLoginAndRegister"
          v-model="form.phone"
          :disabled="fromPlatform"
          :tabIndexNum="'3'"
          :validate-event="Boolean(form.phone)"
          placeholer="手机号"
          :maxLength="11"
          @input="handlePhoneChange"
        >
          <template #prepend>
            <el-select
              :disabled="true"
              v-model="form.pretel"
              style="width: 100px"
            >
              <el-option
                v-for="item in preTelList"
                :value="item"
                :label="'+' + item"
                :key="'+' + item.toString()"
              >
                + {{ item }}
              </el-option>
            </el-select>
          </template>
        </BaseInput>
        <div v-else class="input-custom-disabled">
          +{{ form.pretel }}&nbsp;&nbsp;{{ form.phone | phoneFormat }}
        </div>
      </el-form-item>

      <!-- 验证码 -->
      <el-form-item class="form-item-primary" prop="verification_code">
        <BaseInput
          v-model.trim="form.verification_code"
          :maxlength="smsLength"
          :validate-event="Boolean(form.verification_code)"
          placeholer="验证码"
          :tabIndexNum="'4'"
          @focus="changeCode"
          @input="handleCodeChange"
        >
          <template #btn>
            <VerificationCode
              ref="verification"
              @click="sendCode"
              :account="form.phone"
              :from="'register'"
              :isActive="activeSms"
            />
          </template>
          <template #prefix> 验证码 </template>
        </BaseInput>
      </el-form-item>
    </el-form>
    <!-- 协议及订阅 -->
    <template v-if="hasAgreement">
      <Agreement
        v-model="form.agreement"
        class="aggrement-unset nissan-aggrement"
      />
    </template>

    <el-button
      class="button-custom"
      tabindex="6"
      @click="submit"
      v-track="{
        type: 'click',
        name: `${$route.params.type || 'phone'}.${
          $route.params.step || 'account'
        }.${fromEvent ? 'enterEvent' : 'registerUser'}`,
      }"
      >{{ detailSubmitText }}
      <div class="user-custom-tips" v-if="isMergeLoginAndRegister">
        <p>{{ customContent.Owndesc }}</p>
      </div>
    </el-button>
    <img src="./images/wx-icon.png" class="wx-back" @click="back" v-if="ixWX" />
  </div>
</template>

<script>
import VerificationCode from '@/components/login/VerificationCode.vue'
import BaseMixin from '@/mixins/BaseMixin'
import { checkPhone, checkSMSCode } from '@/utils/validate-rules'
import { getBusinessType } from '@/constant'
import store from '@/store'
import handleSaveAndJump from '@/utils/saveLogin.js'
import _throttle from 'lodash/throttle'
import { getItem } from '@/utils/storage-main'
import { handleBusinessRegiser } from '@/utils/mutiple.js'
import { gotinTrack } from '@frontend/gotin-track'
import { isNeedHandleSMSActive } from '@/utils/consts'
import { setExtraParams } from '@/utils/utils'
import tipsIcon from '@/assets/images/login/tips.svg'
import Agreement from '@/components/login/Agreement'
import { isWechat } from '@/utils/index'

export default {
  name: '',
  props: {},
  mixins: [BaseMixin],
  data() {
    return {
      form: {
        phone: '',
      },
      isWrong: false,
      registeredPhone: '',
      tipsIcon: tipsIcon,
    }
  },

  components: { VerificationCode, Agreement },

  computed: {
    ixWX() {
      return isWechat()
    },
    smsLength() {
      return store.state.smsLength
    },
    activeSms() {
      return store.state.activeSms
    },
    passAccount() {
      return checkPhone(this.currentAccount)
    },
    isMergeLoginAndRegister() {
      return getBusinessType().isMergeLoginAndRegister
    },
    customContent() {
      return getBusinessType()
    },
    hasAgreement() {
      return !this.fromGuest
    },
    detailSubmitText() {
      return this.$t('login.loginPage.porscheLogin')
    },
    rules() {
      return {
        phone: [
          {
            required: true,
            message: this.$t('login.register.labelRegisteredPhone'),
            trigger: 'blur',
          },
          {
            validator: async (rule, value, callback) => {
              // 已知已注册号码不再提交请求进行多次校验
              this.hasChangePhone()
              if (this.registeredPhone)
                return callback(new Error(this.$t('login.register.exists')))

              if (checkPhone(value)) {
                // 检测是否注册
                if (!getBusinessType().isMergeLoginAndRegister) {
                  await this.handleCheckUserValidator(value, callback)
                } else {
                  callback()
                }
              } else {
                return callback(
                  new Error(this.$t('login.resetPassword.validPhone'))
                )
              }
              return callback(
                new Error(this.$t('login.resetPassword.validPhone'))
              )
            },
            trigger: 'blur',
          },
        ],
        verification_code: [
          {
            required: true,
            message: this.$t('login.register.labelCode'),
          },
          {
            validator: (rule, value, callback) => {
              if (this.isWrong) {
                callback(
                  new Error(this.$t('login.loginPage.wrongSecurityCode'))
                )
              } else {
                callback()
              }
            },
          },
        ],
      }
    },
  },

  created() {
    this._initData()
  },

  methods: {
    _initData() {
      setExtraParams()
    },
    // 验证码输入监听
    handleCodeChange: _throttle(function (val) {
      if (checkSMSCode(val)) {
        gotinTrack.standaloneSendData({
          name: `form.code_checked`,
          params: { value: val },
        })
      }
    }, 500),
    // 手机号输入监听
    handlePhoneChange: _throttle(function (val) {
      if (isNeedHandleSMSActive()) {
        const isValid = checkPhone(val)

        this.$store.commit('SET_SMSISACTIVE', isValid)

        if (isValid) {
          gotinTrack.standaloneSendData({
            name: `form.phone_checked`,
            params: { value: val },
          })
        }
      }
    }, 500),
    // 修改电话号码
    hasChangePhone() {
      if (this.form.phone !== this.registeredPhone) this.registeredPhone = ''
    },
    changeCode() {
      this.isWrong = false
    },
    sendCode() {
      if (this.registeredPhone) {
        return
      }
      this.$refs['form'].validateField('phone', (vaild) => {
        if (!vaild) {
          if (isNeedHandleSMSActive()) {
            this.$store.commit('SET_SMSISACTIVE', false)
          }
          this.$refs['verification'].send()
        }
      })
    },
    creatParams() {
      const { phone, verification_code } = this.form

      return { phone, verification_code }
    },
    async handleCheckUserValidator(value, callback) {
      try {
        let data = await store.dispatch('CheckUser', {
          user_name: value,
        })
        if (data.data === true) {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.registered = false
          return callback()
        } else {
          // eslint-disable-next-line vue/no-side-effects-in-computed-properties
          this.registered = true
          return callback(new Error(this.$t('login.register.exists')))
        }
      } catch (error) {
        return callback()
      }
    },

    async fetchRegisterData(params) {
      return await store.dispatch('RegisterByPhone', params)
    },
    // 提交注册/加入活动/下一步
    submit: _throttle(
      function () {
        if (!this.hasConfirmArgeement()) {
          return false
        }
        this.$refs['form'].validate(async (valid) => {
          try {
            if (valid) {
              let successData
              // 获取参数
              let params = this.creatParams()
              if (getBusinessType().isNeedTagedSource) {
                params.source = getBusinessType().unionId
              }
              // 分享功能与具体业务方无关，存在相应的字段传递就可以
              if (getBusinessType().isMergeLoginAndRegister) {
                const { phone, verification_code } = this.form
                let { data } = await store.dispatch('CheckUser', {
                  user_name: this.form.phone,
                })
                if (data) {
                  this.isLogin = false
                  // 未注册
                  let registerParams = {
                    firstName: '',
                    lastName: '',
                    password: '',
                    source: getBusinessType().unionId,
                    phone,
                    verification_code,
                  }
                  successData = await handleBusinessRegiser(
                    getItem('business'),
                    registerParams,
                    this.fetchRegisterData
                  )
                } else {
                  this.isLogin = true
                  let loginParams = {
                    user_name: phone,
                    verification_code,
                    source: getBusinessType().unionId,
                  }
                  successData = await store.dispatch(
                    'userSmsLogin',
                    loginParams
                  )
                }
              } else {
                successData = await handleBusinessRegiser(
                  getItem('business'),
                  params,
                  this.fetchRegisterData
                )
              }
              if (successData.code === 0) {
                this.isLogin
                  ? this.$message.success(this.$t('login.loginPage.success'))
                  : this.$message.success(this.$t('login.register.success'))
                handleSaveAndJump(successData.data)
              }
            }
          } catch (error) {
            console.log(error, 'error tips')
            if (error.code === 11010) {
              this.isWrong = true
              this.$refs['form'].validateField('verification_code')
            }
          }
        })
      },
      500,
      { trailing: false }
    ),
    hasConfirmArgeement() {
      if (this.hasAgreement && !this.form.agreement) {
        this.$message.error({
          message: this.$t('login.register.acceptTermsPop'),
          customClass: 'nissan-error-message',
        })
        return false
      }
      return true
    },
    back() {
      this.$emit('back')
    },
  },
}
</script>

<style lang="scss" scoped>
.nissan-phone {
  background-image: url('./images/asset-container.png');
  background-size: 100% 100%;
  padding: 12px 20px;

  .wx-back {
    width: 40px;
    height: 40px;
    position: relative;
    left: 50%;
    transform: translateX(-50%);
    margin-top: 12px;
  }
}
.button-custom {
  border-radius: 0px;
  font-size: 22px;
  color: #222 !important;
  font-weight: 700;
  background-image: url('../../../assets/images/login/nissan-start.png');
  background-size: 100% 100%;
  height: 56px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.form-custom {
  margin-top: 24px;
}
.user-custom-tips {
  font-size: 12px;
  // line-height: 20px;
  margin-top: 4px;
  color: #222;
  text-align: center;
  font-weight: normal;
}
.aggrement-unset {
  margin-top: 12px;
  margin-bottom: 16px;
}
.custom-tips-njcb {
  font-style: normal;
  font-weight: 400;
  font-size: 12px;
  line-height: 20px;
  color: #5c5c5c;
  margin-bottom: 16px;
}
.custom-tips-container {
  display: flex;
  align-items: center;
  font-size: 14px;
  color: #5c5c5c;
  margin-bottom: 16px;
  .njcb-tips-icon {
    width: 20px;
    height: 20px;
  }

  .custom-tips-title {
    margin-left: 10px;
  }
  .custom-sub-title {
    color: #ed2e79;
  }
}
.tips-icons {
  font-size: 22px;
  color: #f2555e;
}
.dialog-desc-pro {
  margin-top: 8px;
}
</style>
<style lang="scss">
.custom-tips-dialog {
  border-radius: 16px;
  .el-dialog__title {
    font-size: 16px;
    font-weight: 600;
    color: #14142a;
  }
  .el-button.el-button--primary {
    height: 40px;
    width: 124px;
    background: linear-gradient(
      95.08deg,
      #fd169c 2.49%,
      #fe497a 47.86%,
      #fe7b59 97.19%
    );
    border-radius: 8px;
    border-color: unset;
  }
  .el-dialog__body {
    font-size: 12px;
    line-height: 18px;
    font-weight: 400;
    padding: 0 38px 14px !important;
  }
  .el-dialog__header {
    padding-top: 44px;
  }
  .proto {
    color: #ed2e79;
    text-decoration: none;
  }
}
.custom-tips-pop {
  width: 272px;
}
.nissan-error-message {
  background-color: rgba(255, 255, 255, 0.4);
  border-color: transparent;
}
</style>
